import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api } from '../lib/api';

export function VerifyEmail() {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    api.get(`/auth/verify-email?token=${token}`)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-base">
      <div className="card w-[400px] p-8 text-center space-y-4">
        <div className="inline-flex items-center gap-2 mb-1">
          <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center font-bold text-white">Cr</div>
          <div className="text-lg font-semibold tracking-tight">Cros<span className="text-secondary-400">ova</span></div>
        </div>

        {status === 'loading' && (
          <>
            <div className="w-8 h-8 border-2 border-primary-500/30 border-t-primary-500 rounded-full animate-spin mx-auto" />
            <p className="text-sm text-white/40">Verifying your email...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-12 h-12 bg-secondary-400/10 rounded-full flex items-center justify-center mx-auto">
              <span className="text-2xl">✓</span>
            </div>
            <h1 className="text-lg font-semibold text-secondary-400">Email verified!</h1>
            <p className="text-[13px] text-white/50">Your email address has been confirmed.</p>
            <Link to="/dashboard/inventory" className="btn-primary block">Go to dashboard</Link>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 className="text-lg font-semibold text-danger">Link invalid or expired</h1>
            <p className="text-[13px] text-white/50">
              This verification link has expired or already been used.
            </p>
            <Link to="/dashboard/settings" className="btn-secondary block">
              Resend verification email
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
